// https://api.notibot.ru/subscribers/{{shop_id}}

import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';


// ----------------------------------------------------------------------


const initialState = {
    list: [],
    total: 0,
    nextCursor: null,
    isLoading: false,
    error: false,
    operations: [],
    balance: 0,
    count: 0,
    user: {}
};


const slice = createSlice({
    name: 'referals',
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },

        stopLoading(state) {
            state.isLoading = false;
        },

        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },

        setReferalsSuccess(state, action) {
            state.list = action.payload.list;
            state.total = action.payload.total;
            state.nextCursor = action.payload.nextCursor;
        },
        appendReferalsSuccess(state, action) {
            state.list = [...state.list, ...action.payload.list];
            state.total = action.payload.total;
            state.nextCursor = action.payload.nextCursor;
        },
        setCountSuccess(state, action) {
            // state.isLoading = false;
            state.count = action.payload;
        },
        setBalanceSuccess(state, action) {
            // state.isLoading = false;
            state.balance = action.payload;
        },
        setOperationsSuccess(state, action) {
            // state.isLoading = false;
            state.operations = action.payload;
        },
        setUserSuccess(state, action) {
            // state.isLoading = false;
            state.user = action.payload;
        },

    }
});

// Reducer
export default slice.reducer;

// Actions
export const { actions } = slice;

// ----------------------------------------------------------------------

export function getReferals(userid, params = {}, append = false) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const { limit = 20, cursor = null, search = '', dateFrom = null, dateTo = null } = params;
            const response = await axios.get('/partners/referrals/tree', {
                params: { limit, cursor, search, dateFrom, dateTo }
            });
            
            const { list = [], total = 0, nextCursor = null } = response.data.data;
            
            if (append) {
                dispatch(slice.actions.appendReferalsSuccess({ list, total, nextCursor }));
            } else {
                dispatch(slice.actions.setReferalsSuccess({ list, total, nextCursor }));
            }
            dispatch(slice.actions.stopLoading());
        } catch (e) {
            dispatch(slice.actions.stopLoading());
            dispatch(slice.actions.hasError(e));
        }
    }
}

export function setCurrentLead(lead) {
    return (dispatch) => {
        dispatch(slice.actions.setLead(lead));
    }
}


